import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import authStore from '~/stores/authStore';

const useStyles = makeStyles(({ spacing, palette }) =>
    createStyles({
        root: {
            paddingTop: spacing(6),
            paddingBottom: spacing(6)
        },
        label: {
            marginBottom: spacing(1),
            fontWeight: 600
        },
        code: {
            background: palette.grey[900],
            color: '#e8e8e8',
            padding: spacing(3),
            borderRadius: 4,
            fontFamily: '"Courier New", Courier, monospace',
            fontSize: 13,
            lineHeight: 1.7,
            overflowX: 'auto',
            whiteSpace: 'pre'
        },
    })
);

const requestCode = `curl -X POST \\
  https://rest.connect-api.com/speech/transcribe \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -F "file=@call_recording.mp3"`;

const responseCode = `{
  "duration": 183,
  "cost": 0.58,
  "text": "Менеджер: Добрый день, компания...",
  "segments": [
    {
      "speaker": "Speaker 1",
      "start": 0.0,
      "end": 4.8,
      "text": "Добрый день, компания Ромашка."
    },
    {
      "speaker": "Speaker 2",
      "start": 5.1,
      "end": 9.3,
      "text": "Здравствуйте, я хотел уточнить..."
    }
  ]
}`;

const langLib = {
    en: {
        sectionTitle: 'SIMPLE REST API',
        request: 'Request',
        response: 'Response'
    },
    ru: {
        sectionTitle: 'ПРОСТОЙ REST API',
        request: 'Запрос',
        response: 'Ответ'
    }
} as const;

const SpeechCodeExample = () => {
    const classes = useStyles();
    const { lang } = authStore;
    const lib = langLib[lang];

    return (
        <Container maxWidth="md">
            <div className={classes.root}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h2" align="center">
                            {lib['sectionTitle']}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Typography variant="subtitle2" className={classes.label}>
                            {lib['request']}
                        </Typography>
                        <div className={classes.code}>{requestCode}</div>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Typography variant="subtitle2" className={classes.label}>
                            {lib['response']}
                        </Typography>
                        <div className={classes.code}>{responseCode}</div>
                    </Grid>
                </Grid>
            </div>
        </Container>
    );
};

export default observer(SpeechCodeExample);
